




































































import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";

export class SearchCondition {
  nendo: string = ""
  streaming_date_from: string = ""
  streaming_date_to: string = ""
  grade_id: string = ""
  name: string = ""
  action: string = ""
}

export interface StreamingLog {
  actioned_at: Date
	name: string
	grade_id: number
	room_id: number
	number: number
  action: string
}

export interface Data {
  condition: SearchCondition
  streaming_logs: StreamingLog[]
  page: number
  fields: any[]
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      streaming_logs: [],
      page: 1,
      fields: [
        {key: "actioned_at", label: "日時", sortable: true, class: 'text-center b-table-th-td'},
        {key: "action", label: "操作", sortable: true, class: 'text-center b-table-th-td'},
        {key: "grade_id", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        {key: "room_id", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "number", label: "番号", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
      ],
      errors: [],
    });

    /******************************
     * 日時を画面表示文言にコンバート
     ******************************/

    const convertDate = (date: string, format: string) => {
      return Common.formatDate(date, format);
    };

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.page = 1;
      search();
    };

    const changePage = (page: number) => {
      state.page = page;
    }

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
      state.condition.nendo = context.root.$store.getters.getCurrentNendo();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      state.errors = [];
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/streaming_log_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.streaming_logs = response.data.streaming_logs;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * ダウンロード
     ******************************/

    const download = async () => {

      state.errors = []

      context.root.$store.dispatch("showOverlay");

      try{
        let csvData = '';

        const header = ["日時", "操作", "学年", "クラス", "番号", "氏名"];
        csvData += header.join(',') + '\r\n';

        state.streaming_logs.forEach(x => {
          const cols = [];
          cols.push(Common.formatDate(x.actioned_at, "Y年M月D日 HH時mm分"));
          cols.push(x.action);
          cols.push(context.root.$store.getters.getGradeNameByValue(x.grade_id));
          cols.push(x.room_id);
          cols.push(x.number);
          cols.push(x.name);
          csvData += cols.join(',') + '\r\n';
        });

        const link = document.createElement('a');
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        let blob: any = null;
        const csvName = `視聴ログ`;

        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csvData], {type: 'text/csv'});
          window.navigator.msSaveOrOpenBlob(blob, csvName);
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csvData], {type: 'text/csv'});
          link.setAttribute('download', csvName);
          link.setAttribute('href', window.webkitURL.createObjectURL(blob));
          link.click();
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csvData], {type: 'text/csv'});
          link.setAttribute('download', csvName);
          link.setAttribute('href', window.URL.createObjectURL(blob));
          link.click();
        }
      }catch (error) {
        state.errors = [error];
      }
      
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      clearCondition();
      await search();
    });

    return {
      ...toRefs(state),
      search,
      searchClick,
      convertDate,
      clearCondition,
      download,
      changePage,
    }
  }
});
